import React, { useEffect, useRef, useState } from "react";
import {
  Typography,
  Stack,
  Box,
  InputLabel,
  TextField,
  IconButton,
  Card,
  CardContent,
  useMediaQuery,
  Select,
  MenuItem,
  FormControl,
  styled,
  Button,
  Modal,
} from "@mui/material";
import { ReactComponent as AddContactIcon } from "../../../../Icons/AddContactIcon.svg";
import { ReactComponent as UploadFileIcon } from "../../../../Icons/UploadFileIcon.svg";
import { ReactComponent as ImgIcon } from "../../../../Icons/ImgIcon.svg";
import ClearIcon from "@mui/icons-material/Clear";
import { useForm, Controller } from "react-hook-form";
import { DatePicker } from "@mui/x-date-pickers/DatePicker";
import { DateTimePicker } from "@mui/x-date-pickers/DateTimePicker";
import dayjs from "dayjs";
import { ReactComponent as FormIcon } from "../../../../Icons/CommonFormIcon.svg";
import ArrowBackIcon from "@mui/icons-material/ArrowBack";
import PhoneInput from "react-phone-input-2";
import "react-phone-input-2/lib/style.css";
import CloseOutlinedIcon from "@mui/icons-material/CloseOutlined";
import axios from "axios";
import { ToastContainer, toast } from "react-toastify";
import "react-toastify/dist/ReactToastify.css";
import { AdapterDayjs } from "@mui/x-date-pickers/AdapterDayjs";
import { LocalizationProvider } from "@mui/x-date-pickers/LocalizationProvider";
import { DemoContainer } from "@mui/x-date-pickers/internals/demo";
import { HostelGetAll } from '../../../../Redux/Feature/CommonSlice'
import { useDispatch } from 'react-redux'
import axiosInstance from "../../../../api/axiosInstance";
import { useNavigate } from "react-router-dom";
import { removeData } from "../../../../Redux/Feature/AdminSlice";
import PhoneInputController from "../../../../CommonComponents/PhoneInputController";
import { useTranslation } from "react-i18next";

export default function Information({
  setStepperCount,
  setPersonalData,
  PersonalData,
  email,
  setFlowCount,
}) {
  const style = {
    position: "absolute",
    top: "50%",
    left: "50%",
    transform: "translate(-50%, -50%)",
    width: 600,
    bgcolor: "background.paper",
    border: "0px solid #000",
    boxShadow: 24,
    borderRadius: "10px",
    p: 6,
  };

  console.log(email)
  const dispatch = useDispatch()
  const {t} = useTranslation()

  useEffect(() => {
    dispatch(HostelGetAll())
  },[])


  console.log(PersonalData)
  const [open, setOpen] = React.useState(false);
  const handleOpen = () => setOpen(true);
  const handleClose = () => setOpen(false);

  // const StyledPhoneInput = styled(PhoneInput)(({ theme, error }) => ({
  //   '& .form-control': {
  //     width: '100%',
  //     height: '54px',
  //     padding: '15px 55px',
  //     fontSize: '16px',
  //     backgroundColor: 'rgb(249, 250, 251)',
  //     borderRadius: '7px',
  //     border: `1px solid ${error ? '#ff5e74' : 'rgba(0, 0, 0, 0.23)'}`,
  //     '&:focus': {
  //       borderColor: error ? '#ff5e74' : 'rgba(0, 0, 0, 0.23)',
  //     },
  //   },
  //   '& .flag-dropdown': {
  //     backgroundColor: 'rgb(249, 250, 251)',
  //     borderRadius: '7px 0 0 7px',
  //     borderColor: error ? '#ff5e74' : 'rgba(0, 0, 0, 0.23)',
  //   },
  // }));

  useEffect(() => {
    setTimeout(() => {
      window.scrollTo({
        top: 0,
        left: 0,
        behavior: "smooth",
      });
    });
  }, []);

  const ipaFile = useRef();
  const passportFile = useRef()
  const isMobile = useMediaQuery("(max-width:600px)");
  const {
    control,
    handleSubmit,
    formState: { errors },
    getValues,
    watch,
    setValue,
  } = useForm({
    mode: "onTouched",
    shouldUnregister: false,
  });

  const initial_Emergency_contact = {
    Emergency_name: "",
    Emergency_contact_no: "",
    Emergency_email: "",
    Emergency_whatsapp: "",
    Emergency_wechat: "",
    Emergency_line: "",
    Emergency_kakaotalk: "",
    Emergency_zalo: "",
  };

  const { Details, Emergency_contact } = PersonalData;

  const [loading, setLoading] = useState(true)
  const navigate = useNavigate()
  
  // useEffect(() => {
  //   setValue('contact_no', PersonalData?.Details?.contact_no || '')
  //   setValue('line', PersonalData?.Details?.line || '')
  //   setValue('wechat', PersonalData?.Details?.wechat || '')
  //   setValue('whatsapp', PersonalData?.Details?.whatsapp || '')
  //   setValue('kakaotalk', PersonalData?.Details?.kakaotalk || '')
  //   setValue('zalo', PersonalData?.Details?.zalo || '')

  //   Emergency_contact.forEach((item, index) => {
  //     setValue(`Emergency_line_${index + 1}`, item.Emergency_line || '');
  //     setValue(`Emergency_contact_no_${index + 1}`, item.Emergency_contact_no || '');
  //     setValue(`Emergency_name_${index + 1}`, item.Emergency_name || '');
  //     setValue(`Emergency_email_${index + 1}`, item.Emergency_email || '');
  //     setValue(`Emergency_whatsapp_${index + 1}`, item.Emergency_whatsapp || '');
  //     setValue(`Emergency_wechat_${index + 1}`, item.Emergency_wechat || '');
  //     setValue(`Emergency_kakaotalk_${index + 1}`, item.Emergency_kakaotalk || '');
  //     setValue(`Emergency_zalo_${index + 1}`, item.Emergency_zalo || '');
  //   });
  // }, [PersonalData])


  useEffect(() => {
    const details = PersonalData?.Details || {};
    if (details.contact_no) setValue('contact_no', details.contact_no);
    if (details.line) setValue('line', details.line);
    if (details.wechat) setValue('wechat', details.wechat);
    if (details.whatsapp) setValue('whatsapp', details.whatsapp);
    if (details.kakaotalk) setValue('kakaotalk', details.kakaotalk);
    if (details.zalo) setValue('zalo', details.zalo);
  
    const emergencyContacts = PersonalData?.Emergency_contact || [];
    emergencyContacts.forEach((item, index) => {
      if (item.Emergency_line) setValue(`Emergency_line_${index + 1}`, item.Emergency_line);
      if (item.Emergency_contact_no) setValue(`Emergency_contact_no_${index + 1}`, item.Emergency_contact_no);
      if (item.Emergency_name) setValue(`Emergency_name_${index + 1}`, item.Emergency_name);
      if (item.Emergency_email) setValue(`Emergency_email_${index + 1}`, item.Emergency_email);
      if (item.Emergency_whatsapp) setValue(`Emergency_whatsapp_${index + 1}`, item.Emergency_whatsapp);
      if (item.Emergency_wechat) setValue(`Emergency_wechat_${index + 1}`, item.Emergency_wechat);
      if (item.Emergency_kakaotalk) setValue(`Emergency_kakaotalk_${index + 1}`, item.Emergency_kakaotalk);
      if (item.Emergency_zalo) setValue(`Emergency_zalo_${index + 1}`, item.Emergency_zalo);
    });
  }, [PersonalData]);
  
  const Imgwatch = watch("ipa");
  const PassportWatch = watch('passport')
  const EmailWatch = watch("email");

  console.log(Imgwatch)
  console.log(PassportWatch)

  useEffect(() => {
    if(Details){
      setValue("ipa", Details?.ipaFile);
      setValue("passport", Details?.passport);
      setLoading(false)
    }
  }, [Details]);


  if(loading){
    return <p>Loading...</p>
  }

  console.log(ipaFile, "ipafile from information");
  const onSubmit = async (data) => {
    const {
      name,
      dob,
      nationality,
      gender,
      passport_no,
      school,
      contact_no,
      wechat,
      whatsapp,
      line,
      kakaotalk,
      note,
      ipa,
      zalo,
      passport
    } = data;

    console.log(passport)

    const Emerdataas = Emergency_contact.map((itm, index) => ({
      Emergency_name: data[`Emergency_name_${index + 1}`],
      Emergency_contact_no: data[`Emergency_contact_no_${index + 1}`],
      Emergency_email: data[`Emergency_email_${index + 1}`],
      Emergency_whatsapp: data[`Emergency_whatsapp_${index + 1}`],
      Emergency_wechat: data[`Emergency_wechat_${index + 1}`],
      Emergency_line: data[`Emergency_line_${index + 1}`],
      Emergency_kakaotalk: data[`Emergency_kakaotalk_${index + 1}`],
      Emergency_zalo: data[`Emergency_zalo_${index + 1}`],
    }));

    setPersonalData({
      Details: {
        name: name,
        dob: dob,
        nationality: nationality,
        gender: gender,
        passport_no: passport_no,
        school: school,
        contact_no: contact_no,
        wechat: wechat,
        whatsapp: whatsapp,
        line: line,
        kakaotalk: kakaotalk,
        zalo: zalo,
        note: note,
        ipaFile: ipa,
        passport
      },
      Emergency_contact: Emerdataas,
    });

    const Obj = {
      Details: {
        name: name,
        dob: dob,
        nationality: nationality,
        gender: gender,
        passport_no: passport_no,
        school: school,
        contact_no: contact_no,
        wechat: wechat,
        whatsapp: whatsapp,
        line: line,
        kakaotalk: kakaotalk,
        zalo : zalo,
        note: note,
        ipaFile: ipa,
        passport
      },
      Emergency_contact: Emerdataas,
    };
    setStepperCount(2);

    const formData = new FormData();
    formData.append("email", email);
    formData.append("PersonalData", JSON.stringify(Obj));
    formData.append("ipaFile", ipa[0]);
    formData.append("passport", passport[0]);
    await axiosInstance
      .post(
        `add-application-step-data`,
        formData, {
          headers : {
            'Content-Type': 'multipart/form-data',
          }
        }
      )
      .then((response) => console.log(response))
      .catch((error) => {
      console.log(error)
      if(error.response.status === 401){
          navigate('/login')
          dispatch(removeData())
      }
    }
      );

    // HandleSubmitSteps()
  };

  const handleImage = () => {
    ipaFile.current.click();
  };

  const handleDeleteContact = (ind) => {
    const updatedEmergencyContacts = Emergency_contact.filter(
      (_, index) => index !== ind
    );

    // Clear the values of the removed emergency contact fields
    setValue(`Emergency_name_${ind + 1}`, "");
    setValue(`Emergency_contact_no_${ind + 1}`, "");
    setValue(`Emergency_email_${ind + 1}`, "");
    setValue(`Emergency_whatsapp_${ind + 1}`, "");
    setValue(`Emergency_wechat_${ind + 1}`, "");
    setValue(`Emergency_line_${ind + 1}`, "");
    setValue(`Emergency_kakaotalk_${ind + 1}`, "");
    setValue(`Emergency_zalo_${ind + 1}`, "");

    setPersonalData((prev) => ({
      ...prev,
      Emergency_contact: updatedEmergencyContacts,
    }));
  };


  return (
    <>
      <Box sx={{ display: "flex", justifyContent: "center" }}>
        <ToastContainer />
        <Card
          sx={{ width: "90%", border: "0px solid #E5E7EB", boxShadow: "none" }}
        >
          <CardContent style={{ padding: 0, margin: 0 }}>
            <Box
              sx={{
                color: "black",
                margin: "10px 40px 10px 0px",
                cursor: "pointer",
                "&:hover": {
                  color: "black",
                },
              }}
            >
              <ArrowBackIcon
                sx={{
                  border: "1px solid grey",
                  padding: "2px 3px",
                  fontSize: "2rem",
                  borderRadius: "3px",
                }}
                onClick={() => {
                  setFlowCount(1);
                }}
              />
            </Box>
            <Typography
              style={{
                fontSize: "1.7rem",
                fontWeight: 700,
                margin: "30px 0px 40px 0px",
              }}
            >
              {t("Applicant Information")}
            </Typography>
          </CardContent>
        </Card>
      </Box>

      <Box sx={{ display: "flex", justifyContent: "center" }}>
        <Card
          sx={{
            width: "90%",
            border: "1px solid #E5E7EB",
            borderRadius: "6px",
            mb: "30px",
          }}
        >
          <CardContent style={{ padding: 0, margin: 0 }}>
            <form onSubmit={handleSubmit(onSubmit)}>
              <Box sx={{ width: "100%" }}>
                <Box sx={{ display: "flex", justifyContent: "space-between" }}>
                  <Box
                    sx={{
                      display: "flex",
                      justifyContent: "flex-between",
                      alignItems: "center",
                      backgroundColor: "#FCFCFD",
                      padding: 2,
                      border: "1px solid #E5E7EB",
                      borderRadius: "6px 6px 0px 0px",
                      width: "100%",
                    }}
                  >
                    <Box
                      sx={{
                        display: "flex",
                        justifyContent: "flex-between",
                        alignItems: "center",
                        backgroundColor: "#FCFCFD",
                        width: "100%",
                      }}
                    >
                      <FormIcon style={{ marginRight: "10px" }} />
                      <Typography variant="h6_1">{t("Personal Details")}</Typography>
                    </Box>
                  </Box>
                </Box>

                <Box
                  sx={{
                    display: "flex",
                    justifyContent: "space-around",
                    flexWrap: "wrap",
                    gap: "20px",
                    mt: "20px",
                    mb: "30px",
                  }}
                >
                  <Stack sx={{ width: { xs: "90%", lg: "45%" } }}>
                    <InputLabel
                      sx={{
                        mb: 1,
                        fontSize: "18px",
                        fontWeight: 600,
                        color: "black",
                      }}
                    >
                      {errors?.name ? `${t("name")}*` : `${t("name")}*`}
                    </InputLabel>
                    <Controller
                      name="name"
                      control={control}
                      defaultValue={Details?.name}
                      rules={{
                        required: "Name is required",
                        maxLength: {
                          value: 70,
                          message: "Name cannot exceed 70 Characters",
                        },
                        minLength : {
                          value: 3,
                          message: "Name cannot below 3 Characters",
                        }
                        // pattern: {
                        //   value: /^[0-9]+$/,
                        //   message: "Contact number must contain digits only",
                        // },
                      }}
                      render={({ field }) => (
                        <TextField
                          placeholder="Enter name"
                          error={Boolean(errors?.name) ? true : false}
                          {...field}
                          sx={{
                            width: "100%",
                            backgroundColor: "rgb(249, 250, 251)",
                            borderRadius: 0,
                            "& .MuiInputBase-input": {
                              color: errors?.name ? "red" : "black",
                            },
                            "& .MuiOutlinedInput-root": {
                              "& fieldset": {
                                borderColor: errors?.name
                                  ? "#ff5e74"
                                  : "rgba(0, 0, 0, 0.23)",
                              },
                              "&:hover fieldset": {
                                borderColor: errors?.name
                                  ? "#ff5e74"
                                  : "rgba(0, 0, 0, 0.23)",
                              },
                              "&.Mui-focused fieldset": {
                                borderColor: errors?.name
                                  ? "#ff5e74"
                                  : "rgba(0, 0, 0, 0.23)",
                              },
                            },
                          }}
                        />
                      )}
                    />
                    {errors?.name ? (
                      <Typography
                        style={{ color: "#ff5e74", margin: "0.3rem" }}
                      >
                        {errors?.name?.message}
                      </Typography>
                    ) : null}
                  </Stack>

                  <Stack sx={{ width: { xs: "90%", lg: "45%" } }}>
                    <InputLabel
                      sx={{
                        mb: 1,
                        fontSize: "18px",
                        fontWeight: 600,
                        color: "black",
                      }}
                    >
                      {errors?.dob ? `${t("dob")}*` : `${t("dob")}*`}
                    </InputLabel>
                    <Controller
                      name="dob"
                      control={control}
                      defaultValue={Details?.dob ? dayjs(Details?.dob) : null}
                      
                      rules={{ required: true }}
                      render={({ field }) => (
                        <LocalizationProvider dateAdapter={AdapterDayjs}>
                          <DemoContainer components={["DatePicker"]}>
                            <DatePicker
                              {...field}
                              sx={{
                                width: "100%",
                                backgroundColor: "rgb(249, 250, 251)",
                                ".MuiSvgIcon-root": { fill: "#1A2461" },
                                "& .MuiInputBase-input": {
                                  color: errors?.dob ? "red" : "black", // Text color based on error state
                                },
                                "& .MuiOutlinedInput-root": {
                                  "& fieldset": {
                                    borderColor: errors?.dob
                                      ? "red"
                                      : "rgba(0, 0, 0, 0.23)", // Default border color
                                  },
                                  "&:hover fieldset": {
                                    borderColor: errors?.dob
                                      ? "red"
                                      : "rgba(0, 0, 0, 0.87)", // Hover border color
                                  },
                                  "&.Mui-focused fieldset": {
                                    borderColor: errors?.dob
                                      ? "red"
                                      : "rgba(0, 0, 0, 0.87)", // Focused border color
                                  },
                                },
                              }}
                              format="DD/MM/YYYY"
                              fullWidth
                              maxDate={dayjs()}
                            />
                          </DemoContainer>
                        </LocalizationProvider>
                      )}
                    />
                    {errors?.dob && (
                      <Typography
                        style={{ color: "#ff5e74", margin: "0.3rem" }}
                      >
                        Please select Date of Birth
                      </Typography>
                    )}
                  </Stack>
                </Box>

                <Box
                  sx={{
                    display: "flex",
                    justifyContent: "space-around",
                    flexWrap: "wrap",
                    gap: "20px",
                    mt: "20px",
                    mb: "30px",
                  }}
                >
                  <Stack sx={{ width: { xs: "90%", lg: "45%" } }}>
                    <InputLabel
                      sx={{
                        mb: 1,
                        fontSize: "18px",
                        fontWeight: 600,
                        color: "black",
                      }}
                    >
                      {errors?.nationality ? `${t("nationality")}*` : `${t("nationality")}*`}
                    </InputLabel>
                    <Controller
                      name="nationality"
                      control={control}
                      defaultValue={Details?.nationality}
                      rules={{
                        required: true,
                      }}
                      render={({ field }) => (
                        <FormControl
                          sx={{
                            width: "100%",
                            backgroundColor: "rgb(249, 250, 251)",
                            borderRadius: 0,
                            "& .MuiInputBase-input": {
                              color: errors?.nationality ? "red" : "black",
                            },
                            "& .MuiOutlinedInput-root": {
                              "& fieldset": {
                                borderColor: errors?.nationality
                                  ? "#ff5e74"
                                  : "rgba(0, 0, 0, 0.23)",
                              },
                              "&:hover fieldset": {
                                borderColor: errors?.nationality
                                  ? "#ff5e74"
                                  : "rgba(0, 0, 0, 0.23)",
                              },
                              "&.Mui-focused fieldset": {
                                borderColor: errors?.nationality
                                  ? "#ff5e74"
                                  : "rgba(0, 0, 0, 0.23)",
                              },
                            },
                          }}
                        >
                          <Select
                            {...field}
                            displayEmpty
                            error={Boolean(errors.nationality)}
                            inputProps={{ "aria-label": "Without label" }}
                          >
                            <MenuItem value="" disabled>
                              Select Nationality
                            </MenuItem>
                            <MenuItem value="China">China</MenuItem>
                            <MenuItem value="Taiwan">Taiwan</MenuItem>
                            <MenuItem value="Korea">Korea</MenuItem>
                            <MenuItem value="Thailand">Thailand</MenuItem>
                            <MenuItem value="Vietnam">Vietnam</MenuItem>
                            <MenuItem value="Other">Other</MenuItem>
                          </Select>
                        </FormControl>
                      )}
                    />
                    {errors?.nationality ? (
                      <Typography
                        style={{ color: "#ff5e74", margin: "0.3rem" }}
                      >
                        Please enter nationality
                      </Typography>
                    ) : null}
                  </Stack>

                  <Stack sx={{ width: { xs: "90%", lg: "45%" } }}>
                    <InputLabel
                      sx={{
                        mb: 1,
                        fontSize: "18px",
                        fontWeight: 600,
                        color: "black",
                      }}
                    >
                      {errors?.gender ? `${t("Gender")}*` : `${t("Gender")}*`}
                    </InputLabel>
                    <Controller
                      name="gender"
                      control={control}
                      defaultValue={Details?.gender || ""}
                      rules={{ required: true }}
                      render={({ field }) => (
                        <FormControl
                          sx={{
                            width: "100%",
                            backgroundColor: "rgb(249, 250, 251)",
                            borderRadius: 0,
                            "& .MuiInputBase-input": {
                              color: errors?.gender ? "red" : "black",
                            },
                            "& .MuiOutlinedInput-root": {
                              "& fieldset": {
                                borderColor: errors?.gender
                                  ? "#ff5e74"
                                  : "rgba(0, 0, 0, 0.23)",
                              },
                              "&:hover fieldset": {
                                borderColor: errors?.gender
                                  ? "#ff5e74"
                                  : "rgba(0, 0, 0, 0.23)",
                              },
                              "&.Mui-focused fieldset": {
                                borderColor: errors?.gender
                                  ? "#ff5e74"
                                  : "rgba(0, 0, 0, 0.23)",
                              },
                            },
                          }}
                        >
                          <Select
                            {...field}
                            displayEmpty
                            error={Boolean(errors?.gender)}
                            inputProps={{ "aria-label": "Without label" }}
                          >
                            <MenuItem value="" disabled>
                              Select gender
                            </MenuItem>
                            <MenuItem value="Male">Male</MenuItem>
                            <MenuItem value="Female">Female</MenuItem>
                            {/* <MenuItem value="other">Other</MenuItem> */}
                          </Select>
                        </FormControl>
                      )}
                    />
                    {errors?.gender && (
                      <Typography
                        style={{ color: "#ff5e74", margin: "0.3rem" }}
                      >
                        Please select gender
                      </Typography>
                    )}
                  </Stack>
                </Box>

                <Box
                  sx={{
                    display: "flex",
                    justifyContent: "space-around",
                    flexWrap: "wrap",
                    gap: "20px",
                    mt: "20px",
                    mb: "30px",
                  }}
                >
                  <Stack sx={{ width: { xs: "90%", lg: "45%" } }}>
                    <InputLabel
                      sx={{
                        mb: 1,
                        fontSize: "18px",
                        fontWeight: 600,
                        color: "black",
                      }}
                    >
                      {errors?.passport_no
                        ? `${t("Passport Number")}*`
                        : `${t("Passport Number")}*`}
                    </InputLabel>
                    <Controller
                      name="passport_no"
                      control={control}
                      defaultValue={Details?.passport_no}
                      rules={{
                        required: "Passport number is required",
                        maxLength: {
                          value: 20,
                          message: "Passport number cannot exceed 20 Characters",
                        },
                        minLength : {
                          value: 5,
                          message: "Passport number cannot below 5 Characters",
                        }
                      }}
                      render={({ field }) => (
                        <TextField
                          placeholder="Enter passport number"
                          error={Boolean(errors.passport_no) ? true : false}
                          {...field}
                          sx={{
                            width: "100%",
                            backgroundColor: "rgb(249, 250, 251)",
                            borderRadius: 0,
                            "& .MuiInputBase-input": {
                              color: errors?.passport_no ? "red" : "black",
                            },
                            "& .MuiOutlinedInput-root": {
                              "& fieldset": {
                                borderColor: errors?.passport_no
                                  ? "#ff5e74"
                                  : "rgba(0, 0, 0, 0.23)",
                              },
                              "&:hover fieldset": {
                                borderColor: errors?.passport_no
                                  ? "#ff5e74"
                                  : "rgba(0, 0, 0, 0.23)",
                              },
                              "&.Mui-focused fieldset": {
                                borderColor: errors?.passport_no
                                  ? "#ff5e74"
                                  : "rgba(0, 0, 0, 0.23)",
                              },
                            },
                          }}
                        />
                      )}
                    />
                    {errors?.passport_no ? (
                      <Typography
                        style={{ color: "#ff5e74", margin: "0.3rem" }}
                      >
                        {errors?.passport_no?.message}
                      </Typography>
                    ) : null}
                  </Stack>

                  <Stack sx={{ width: { xs: "90%", lg: "45%" } }}>
                    <InputLabel
                      sx={{
                        mb: 1,
                        fontSize: "18px",
                        fontWeight: 600,
                        color: "black",
                      }}
                    >
                      {errors?.school ? `${t("School")}*` : `${t("School")}*`}
                    </InputLabel>
                    <Controller
                      name="school"
                      control={control}
                      defaultValue={Details?.school}
                      rules={{
                        required: "School name is required",
                        maxLength: {
                          value: 150,
                          message: "School name cannot exceed 150 Characters",
                        },
                        minLength : {
                          value: 3,
                          message: "School name cannot below 3 Characters",
                        }
                      }}
                      render={({ field }) => (
                        <TextField
                          placeholder="Enter school"
                          error={Boolean(errors.school) ? true : false}
                          {...field}
                          sx={{
                            width: "100%",
                            backgroundColor: "rgb(249, 250, 251)",
                            borderRadius: 0,
                            "& .MuiInputBase-input": {
                              color: errors?.school ? "red" : "black",
                            },
                            "& .MuiOutlinedInput-root": {
                              "& fieldset": {
                                borderColor: errors?.school
                                  ? "#ff5e74"
                                  : "rgba(0, 0, 0, 0.23)",
                              },
                              "&:hover fieldset": {
                                borderColor: errors?.school
                                  ? "#ff5e74"
                                  : "rgba(0, 0, 0, 0.23)",
                              },
                              "&.Mui-focused fieldset": {
                                borderColor: errors?.school
                                  ? "#ff5e74"
                                  : "rgba(0, 0, 0, 0.23)",
                              },
                            },
                          }}
                        />
                      )}
                    />
                    {errors?.school ? (
                      <Typography
                        style={{ color: "#ff5e74", margin: "0.3rem" }}
                      >
                        {errors?.school?.message}
                      </Typography>
                    ) : null}
                  </Stack>
                </Box>

                <Box
                  sx={{
                    display: "flex",
                    justifyContent: "flex-start",
                    alignItems: "center",
                    backgroundColor: "#FCFCFD",
                    padding: 2,
                    border: "1px solid #E5E7EB",
                    borderRadius: "6px 6px 0px 0px",
                  }}
                >
                  <FormIcon style={{ marginRight: "10px" }} />
                  <Typography variant="h6_1">{t("Contact")}</Typography>
                </Box>

                <Box
                  sx={{
                    display: "flex",
                    justifyContent: "space-around",
                    flexWrap: "wrap",
                    gap: "20px",
                    mt: "20px",
                    mb: "30px",
                  }}
                >
                  <Stack sx={{ width: { xs: "90%", lg: "45%" } }}>
                    <InputLabel
                      sx={{
                        mb: 1,
                        fontSize: "18px",
                        fontWeight: 600,
                        color: "black",
                      }}
                    >
                      {errors?.contact_no
                        ? `${t("Contact Number")}*`
                        : `${t("Contact Number")}*`}
                    </InputLabel>
                    <PhoneInputController
                            name="contact_no"
                            Details={Details}
                            control={control}
                            rules={{ required: 'Contact number is required' }}
                          />
                    {errors?.contact_no ? (
                      <Typography
                        style={{ color: "#ff5e74", margin: "0.3rem" }}
                      >
                        {errors?.contact_no?.message}
                      </Typography>
                    ) : null}
                  </Stack>

                  <Stack sx={{ width: { xs: "90%", lg: "45%" } }}>
                    <InputLabel
                      sx={{
                        mb: 1,
                        fontSize: "18px",
                        fontWeight: 600,
                        color: "black",
                      }}
                    >
                      {errors?.wechat ? `${t("wechat")}*` : `${t("wechat")}`}
                    </InputLabel>
                    <Controller
                      name="wechat"
                      control={control}
                      defaultValue={Details?.wechat}
                      rules={{
                        required: false,
                        maxLength: {
                          value: 70,
                          message: "We Chat cannot exceed 70 Characters",
                        },
                        minLength : {
                          value: 1,
                          message: "We Chat cannot below 1 Characters",
                        }
                      }}
                      render={({ field }) => (
                        <TextField
                          placeholder="Enter wechat"
                          error={Boolean(errors?.wechat) ? true : false}
                          {...field}
                          sx={{
                            width: "100%",
                            backgroundColor: "rgb(249, 250, 251)",
                            borderRadius: 0,
                            "& .MuiInputBase-input": {
                              color: errors?.wechat ? "red" : "black",
                            },
                            "& .MuiOutlinedInput-root": {
                              "& fieldset": {
                                borderColor: errors?.wechat
                                  ? "#ff5e74"
                                  : "rgba(0, 0, 0, 0.23)",
                              },
                              "&:hover fieldset": {
                                borderColor: errors?.wechat
                                  ? "#ff5e74"
                                  : "rgba(0, 0, 0, 0.23)",
                              },
                              "&.Mui-focused fieldset": {
                                borderColor: errors?.wechat
                                  ? "#ff5e74"
                                  : "rgba(0, 0, 0, 0.23)",
                              },
                            },
                          }}
                        />
                      )}
                    />
                    {errors?.wechat ? (
                      <Typography
                        style={{ color: "#ff5e74", margin: "0.3rem" }}
                      >
                        {errors?.wechat?.message}
                      </Typography>
                    ) : null}
                  </Stack>
                </Box>

                <Box
                  sx={{
                    display: "flex",
                    justifyContent: "space-around",
                    flexWrap: "wrap",
                    gap: "20px",
                    mt: "20px",
                    mb: "30px",
                  }}
                >
                  <Stack sx={{ width: { xs: "90%", lg: "45%" } }}>
                    <InputLabel
                      sx={{
                        mb: 1,
                        fontSize: "18px",
                        fontWeight: 600,
                        color: "black",
                      }}
                    >
                      {errors?.whatsapp ? `${t("whatsapp")}*` : `${t("whatsapp")}`}
                    </InputLabel>
                    <Controller
                      name="whatsapp"
                      control={control}
                      defaultValue={Details?.whatsapp}
                      rules={{
                        required: false,
                        maxLength: {
                          value: 70,
                          message: "WhatsApp cannot exceed 70 Characters",
                        },
                        minLength : {
                          value: 1,
                          message: "WhatsApp cannot below 1 Characters",
                        }
                      }}
                      render={({ field }) => (
                        <TextField
                          placeholder="Enter whatsapp"
                          error={Boolean(errors?.whatsapp) ? true : false}
                          {...field}
                          sx={{
                            width: "100%",
                            backgroundColor: "rgb(249, 250, 251)",
                            borderRadius: 0,
                            "& .MuiInputBase-input": {
                              color: errors?.whatsapp ? "red" : "black",
                            },
                            "& .MuiOutlinedInput-root": {
                              "& fieldset": {
                                borderColor: errors?.whatsapp
                                  ? "#ff5e74"
                                  : "rgba(0, 0, 0, 0.23)",
                              },
                              "&:hover fieldset": {
                                borderColor: errors?.whatsapp
                                  ? "#ff5e74"
                                  : "rgba(0, 0, 0, 0.23)",
                              },
                              "&.Mui-focused fieldset": {
                                borderColor: errors?.whatsapp
                                  ? "#ff5e74"
                                  : "rgba(0, 0, 0, 0.23)",
                              },
                            },
                          }}
                        />
                      )}
                    />
                    {errors?.whatsapp ? (
                      <Typography
                        style={{ color: "#ff5e74", margin: "0.3rem" }}
                      >
                        {errors?.whatsapp?.message}
                      </Typography>
                    ) : null}
                  </Stack>

                  <Stack sx={{ width: { xs: "90%", lg: "45%" } }}>
                    <InputLabel
                      sx={{
                        mb: 1,
                        fontSize: "18px",
                        fontWeight: 600,
                        color: "black",
                      }}
                    >
                      {errors?.line ? `${t("line")}*` : `${t("line")}`}
                    </InputLabel>
                    <Controller
                      name="line"
                      control={control}
                      defaultValue={Details?.line}
                      rules={{
                        required: false,
                        maxLength: {
                          value: 70,
                          message: "LINE cannot exceed 70 Characters",
                        },
                        minLength : {
                          value: 1,
                          message: "LINE cannot below 1 Characters",
                        }
                      }}
                      render={({ field }) => (
                        <TextField
                          placeholder="Enter line"
                          error={Boolean(errors?.line) ? true : false}
                          {...field}
                          sx={{
                            width: "100%",
                            backgroundColor: "rgb(249, 250, 251)",
                            borderRadius: 0,
                            "& .MuiInputBase-input": {
                              color: errors?.line ? "red" : "black",
                            },
                            "& .MuiOutlinedInput-root": {
                              "& fieldset": {
                                borderColor: errors?.line
                                  ? "#ff5e74"
                                  : "rgba(0, 0, 0, 0.23)",
                              },
                              "&:hover fieldset": {
                                borderColor: errors?.line
                                  ? "#ff5e74"
                                  : "rgba(0, 0, 0, 0.23)",
                              },
                              "&.Mui-focused fieldset": {
                                borderColor: errors?.line
                                  ? "#ff5e74"
                                  : "rgba(0, 0, 0, 0.23)",
                              },
                            },
                          }}
                        />
                      )}
                    />
                    {errors?.line ? (
                      <Typography
                        style={{ color: "#ff5e74", margin: "0.3rem" }}
                      >
                        {errors?.line?.message}
                      </Typography>
                    ) : null}
                  </Stack>
                </Box>

                <Box
                  sx={{
                    display: "flex",
                    justifyContent: "space-around",
                    flexWrap: "wrap",
                    gap: "20px",
                    mt: "20px",
                    mb: "30px",
                  }}
                >
                  <Stack sx={{ width: { xs: "90%", lg: "45%" } }}>
                    <InputLabel
                      sx={{
                        mb: 1,
                        fontSize: "18px",
                        fontWeight: 600,
                        color: "black",
                      }}
                    >
                      {errors?.kakaotalk ? `${t("Kakaotalk")}*` : `${t("Kakaotalk")}`}
                    </InputLabel>
                    <Controller
                      name="kakaotalk"
                      control={control}
                      defaultValue={Details?.kakaotalk}
                      rules={{
                        required: false,
                        maxLength: {
                          value: 70,
                          message: "Kakaotalk cannot exceed 70 Characters",
                        },
                        minLength : {
                          value: 1,
                          message: "Kakaotalk cannot below 1 Characters",
                        }
                      }}
                      render={({ field }) => (
                        <TextField
                          placeholder="Enter kakaotalk"
                          error={Boolean(errors?.kakaotalk) ? true : false}
                          {...field}
                          sx={{
                            width: "100%",
                            backgroundColor: "rgb(249, 250, 251)",
                            borderRadius: 0,
                            "& .MuiInputBase-input": {
                              color: errors?.kakaotalk ? "red" : "black",
                            },
                            "& .MuiOutlinedInput-root": {
                              "& fieldset": {
                                borderColor: errors?.kakaotalk
                                  ? "#ff5e74"
                                  : "rgba(0, 0, 0, 0.23)",
                              },
                              "&:hover fieldset": {
                                borderColor: errors?.kakaotalk
                                  ? "#ff5e74"
                                  : "rgba(0, 0, 0, 0.23)",
                              },
                              "&.Mui-focused fieldset": {
                                borderColor: errors?.kakaotalk
                                  ? "#ff5e74"
                                  : "rgba(0, 0, 0, 0.23)",
                              },
                            },
                          }}
                        />
                      )}
                    />
                    {errors?.kakaotalk ? (
                      <Typography
                        style={{ color: "#ff5e74", margin: "0.3rem" }}
                      >
                        {errors?.kakaotalk?.message}
                      </Typography>
                    ) : null}
                  </Stack>

                  <Stack sx={{ width: { xs: "90%", lg: "45%" } }}>
                    <InputLabel
                      sx={{
                        mb: 1,
                        fontSize: "18px",
                        fontWeight: 600,
                        color: "black",
                      }}
                    >
                      {errors?.zalo ? `${t("Zalo")}*` : `${t("Zalo")}`}
                    </InputLabel>
                    <Controller
                      name="zalo"
                      control={control}
                      defaultValue={Details?.zalo}
                      rules={{
                        required: false,
                        maxLength: {
                          value: 70,
                          message: "Zalo cannot exceed 70 Characters",
                        },
                        minLength : {
                          value: 1,
                          message: "Zalo cannot below 1 Characters",
                        }
                      }}
                      render={({ field }) => (
                        <TextField
                          placeholder="Enter zalo"
                          error={Boolean(errors?.zalo) ? true : false}
                          {...field}
                          sx={{
                            width: "100%",
                            backgroundColor: "rgb(249, 250, 251)",
                            borderRadius: 0,
                            "& .MuiInputBase-input": {
                              color: errors?.zalo ? "red" : "black",
                            },
                            "& .MuiOutlinedInput-root": {
                              "& fieldset": {
                                borderColor: errors?.zalo
                                  ? "#ff5e74"
                                  : "rgba(0, 0, 0, 0.23)",
                              },
                              "&:hover fieldset": {
                                borderColor: errors?.zalo
                                  ? "#ff5e74"
                                  : "rgba(0, 0, 0, 0.23)",
                              },
                              "&.Mui-focused fieldset": {
                                borderColor: errors?.zalo
                                  ? "#ff5e74"
                                  : "rgba(0, 0, 0, 0.23)",
                              },
                            },
                          }}
                        />
                      )}
                    />
                    {errors?.zalo ? (
                      <Typography
                        style={{ color: "#ff5e74", margin: "0.3rem" }}
                      >
                        {errors?.zalo?.message}
                      </Typography>
                    ) : null}
                  </Stack>
                </Box>

                <Box
                  sx={{
                    display: "flex",
                    justifyContent: "flex-start",
                    alignItems: "center",
                    backgroundColor: "#FCFCFD",
                    padding: 2,
                    border: "1px solid #E5E7EB",
                    borderRadius: "6px 6px 0px 0px",
                  }}
                >
                  <FormIcon style={{ marginRight: "10px" }} />
                  <Typography variant="h6_1">{t("Emergency Contact")}</Typography>
                </Box>

                {Emergency_contact?.map((item, index) => (
                  <>
                    <Box
                      sx={{
                        display: "flex",
                        justifyContent: "center",
                        margin: "20px",
                      }}
                    >
                      <Card sx={{ width: "95%", border: "1px solid #E5E7EB" }}>
                        <CardContent
                          sx={{ padding: { xs: 1.5, lg: 3 }, marging: 0 }}
                        >
                          <Stack
                            direction="row"
                            alignItems="center"
                            justifyContent="space-between"
                          >
                            <Typography variant={{ xs: "h6_1", lg: "h7_1" }}>
                              {t("Contact")} {index + 1}
                            </Typography>
                            {index > 0 && (
                              <IconButton
                                onClick={() => handleDeleteContact(index)}
                              >
                                {" "}
                                <ClearIcon
                                  sx={{ color: "#f37777", fontSize: "30px" }}
                                />
                              </IconButton>
                            )}
                          </Stack>

                          <Box
                            sx={{
                              display: "flex",
                              justifyContent: "space-evenly",
                              flexWrap: "wrap",
                              gap: "20px",
                              mt: "20px",
                              mb: "30px",
                            }}
                          >
                            <Stack sx={{ width: { xs: "100%", lg: "45%" } }}>
                              <InputLabel
                                sx={{
                                  mb: 1,
                                  fontSize: "18px",
                                  fontWeight: 600,
                                  color: "black",
                                }}
                              >
                                {Boolean(errors[`Emergency_name_${index + 1}`])
                                  ? `${t("name")}*`
                                  : `${t("name")}*`}
                              </InputLabel>
                              <Controller
                                name={"Emergency_name_" + (index + 1)}
                                control={control}
                                defaultValue={
                                  Emergency_contact[index]?.Emergency_name
                                }
                                rules={{
                                  required: "Name is required",
                                  maxLength: {
                                    value: 150,
                                    message: "Name cannot exceed 150 Characters",
                                  },
                                  minLength : {
                                    value: 3,
                                    message: "Name cannot below 3 Characters",
                                  }
                                }}
                                render={({ field }) => (
                                  <TextField
                                    placeholder="Enter name"
                                    error={
                                      Boolean(
                                        errors[`Emergency_name_${index + 1}`]
                                      )
                                        ? true
                                        : false
                                    }
                                    {...field}
                                    sx={{
                                      width: "100%",
                                      backgroundColor: "rgb(249, 250, 251)",
                                      borderRadius: 0,
                                      "& .MuiInputBase-input": {
                                        color: Boolean(
                                          errors[`Emergency_name_${index + 1}`]
                                        )
                                          ? "red"
                                          : "black",
                                      },
                                      "& .MuiOutlinedInput-root": {
                                        "& fieldset": {
                                          borderColor: Boolean(
                                            errors[
                                              `Emergency_name_${index + 1}`
                                            ]
                                          )
                                            ? "#ff5e74"
                                            : "rgba(0, 0, 0, 0.23)",
                                        },
                                        "&:hover fieldset": {
                                          borderColor: Boolean(
                                            errors[
                                              `Emergency_name_${index + 1}`
                                            ]
                                          )
                                            ? "#ff5e74"
                                            : "rgba(0, 0, 0, 0.23)",
                                        },
                                        "&.Mui-focused fieldset": {
                                          borderColor: Boolean(
                                            errors[
                                              `Emergency_name_${index + 1}`
                                            ]
                                          )
                                            ? "#ff5e74"
                                            : "rgba(0, 0, 0, 0.23)",
                                        },
                                      },
                                    }}
                                  />
                                )}
                              />
                              {Boolean(
                                errors[`Emergency_name_${index + 1}`]
                              ) ? (
                                <Typography
                                  style={{ color: "#ff5e74", margin: "0.3rem" }}
                                >
                                  Please enter name
                                </Typography>
                              ) : null}
                            </Stack>

                            <Stack sx={{ width: { xs: "100%", lg: "45%" } }}>
                              <InputLabel
                                sx={{
                                  mb: 1,
                                  fontSize: "18px",
                                  fontWeight: 600,
                                  color: "black",
                                }}
                              >
                                {Boolean(
                                  errors[`Emergency_contact_no_${index + 1}`]
                                )
                                  ? `${t("Contact Number")}*`
                                  : `${t("Contact Number")}*`}
                              </InputLabel>
                              <PhoneInputController
                                  name={"Emergency_contact_no_" + (index + 1)}
                                  control={control}
                                  rules={{ required: 'Emergency contact number is required' }}
                                />
                              {Boolean(
                                errors[`Emergency_contact_no_${index + 1}`]
                              ) ? (
                                <Typography
                                  style={{ color: "#ff5e74", margin: "0.3rem" }}
                                >
                                  {errors[`Emergency_contact_no_${index + 1}`]?.message}
                                </Typography>
                              ) : null}
                            </Stack>
                          </Box>

                          <Box
                            sx={{
                              display: "flex",
                              justifyContent: "space-evenly",
                              flexWrap: "wrap",
                              gap: "20px",
                              mt: "20px",
                              mb: "30px",
                            }}
                          >
                            <Stack sx={{ width: { xs: "100%", lg: "45%" } }}>
                              <InputLabel
                                sx={{
                                  mb: 1,
                                  fontSize: "18px",
                                  fontWeight: 600,
                                  color: "black",
                                }}
                              >
                                {Boolean(errors[`Emergency_email_${index + 1}`])
                                  ? `${t("email")}*`
                                  : `${t("email")}*`}
                              </InputLabel>
                              <Controller
                                name={"Emergency_email_" + (index + 1)}
                                defaultValue={
                                  Emergency_contact[index]?.Emergency_email
                                }
                                control={control}
                                rules={{
                                  required: true,
                                  pattern: {
                                    value: /^[^\s@]+@[^\s@]+\.[^\s@]+$/,
                                    message: "Invalid email address",
                                  },
                                }}
                                render={({ field }) => (
                                  <TextField
                                    placeholder="Enter email"
                                    error={
                                      Boolean(
                                        errors[`Emergency_email_${index + 1}`]
                                      )
                                        ? true
                                        : false
                                    }
                                    {...field}
                                    sx={{
                                      width: "100%",
                                      backgroundColor: "rgb(249, 250, 251)",
                                      borderRadius: 0,
                                      "& .MuiInputBase-input": {
                                        color: Boolean(
                                          errors[`Emergency_email_${index + 1}`]
                                        )
                                          ? "red"
                                          : "black",
                                      },
                                      "& .MuiOutlinedInput-root": {
                                        "& fieldset": {
                                          borderColor: Boolean(
                                            errors[
                                              `Emergency_email_${index + 1}`
                                            ]
                                          )
                                            ? "#ff5e74"
                                            : "rgba(0, 0, 0, 0.23)",
                                        },
                                        "&:hover fieldset": {
                                          borderColor: Boolean(
                                            errors[
                                              `Emergency_email_${index + 1}`
                                            ]
                                          )
                                            ? "#ff5e74"
                                            : "rgba(0, 0, 0, 0.23)",
                                        },
                                        "&.Mui-focused fieldset": {
                                          borderColor: Boolean(
                                            errors[
                                              `Emergency_email_${index + 1}`
                                            ]
                                          )
                                            ? "#ff5e74"
                                            : "rgba(0, 0, 0, 0.23)",
                                        },
                                      },
                                    }}
                                  />
                                )}
                              />
                              {Boolean(
                                errors[`Emergency_email_${index + 1}`]
                              ) ? (
                                <Typography
                                  style={{ color: "#ff5e74", margin: "0.3rem" }}
                                >
                                  Please enter email
                                </Typography>
                              ) : null}
                            </Stack>

                            <Stack sx={{ width: { xs: "100%", lg: "45%" } }}>
                              <InputLabel
                                sx={{
                                  mb: 1,
                                  fontSize: "18px",
                                  fontWeight: 600,
                                  color: "black",
                                }}
                              >
                                {Boolean(
                                  errors[`Emergency_whatsapp_${index + 1}`]
                                )
                                  ? `${t("whatsapp")}*`
                                  : `${t("whatsapp")}`}
                              </InputLabel>
                    <Controller
                      name={"Emergency_whatsapp_" + (index + 1)}
                      control={control}
                      rules={{
                        required: false,
                        maxLength: {
                          value: 70,
                          message: "WhatsApp cannot exceed 70 Characters",
                        },
                        minLength : {
                          value: 1,
                          message: "WhatsApp cannot below 1 Characters",
                        }
                      }}
                      render={({ field }) => (
                        <TextField
                          placeholder="Enter WhatsApp"
                          error={Boolean(
                            errors[`Emergency_whatsapp_${index + 1}`]
                          ) ? true : false}
                          {...field}
                          sx={{
                            width: "100%",
                            backgroundColor: "rgb(249, 250, 251)",
                            borderRadius: 0,
                            "& .MuiInputBase-input": {
                              color: Boolean(
                                errors[`Emergency_whatsapp_${index + 1}`]
                              ) ? "red" : "black",
                            },
                            "& .MuiOutlinedInput-root": {
                              "& fieldset": {
                                borderColor: Boolean(
                                  errors[`Emergency_whatsapp_${index + 1}`]
                                )
                                  ? "#ff5e74"
                                  : "rgba(0, 0, 0, 0.23)",
                              },
                              "&:hover fieldset": {
                                borderColor: Boolean(
                                  errors[`Emergency_whatsapp_${index + 1}`]
                                )
                                  ? "#ff5e74"
                                  : "rgba(0, 0, 0, 0.23)",
                              },
                              "&.Mui-focused fieldset": {
                                borderColor: Boolean(
                                  errors[`Emergency_whatsapp_${index + 1}`]
                                )
                                  ? "#ff5e74"
                                  : "rgba(0, 0, 0, 0.23)",
                              },
                            },
                          }}
                        />
                      )}
                    />
                    {Boolean(
                            errors[`Emergency_whatsapp_${index + 1}`]
                          ) ? (
                      <Typography
                        style={{ color: "#ff5e74", margin: "0.3rem" }}
                      >
                        {errors[`Emergency_whatsapp_${index + 1}`]?.message}
                      </Typography>
                    ) : null}
                  </Stack>
                              
                              
                          </Box>

                          <Box
                            sx={{
                              display: "flex",
                              justifyContent: "space-evenly",
                              flexWrap: "wrap",
                              gap: "20px",
                              mt: "20px",
                              mb: "30px",
                            }}
                          >
                            <Stack sx={{ width: { xs: "100%", lg: "45%" } }}>
                              <InputLabel
                                sx={{
                                  mb: 1,
                                  fontSize: "18px",
                                  fontWeight: 600,
                                  color: "black",
                                }}
                              >
                                {Boolean(
                                  errors[`Emergency_wechat_${index + 1}`]
                                )
                                  ? `${t("wechat")}*`
                                  : `${t("wechat")}`}
                              </InputLabel>
                              <Controller
                      name={"Emergency_wechat_" + (index + 1)}
                      control={control}
                      rules={{
                        required: false,
                        maxLength: {
                          value: 70,
                          message: "We Chat cannot exceed 70 Characters",
                        },
                        minLength : {
                          value: 1,
                          message: "We Chat cannot below 1 Characters",
                        }
                      }}
                      render={({ field }) => (
                        <TextField
                          placeholder="Enter wechat"
                          error={Boolean(
                            errors[`Emergency_wechat_${index + 1}`]
                          ) ? true : false}
                          {...field}
                          sx={{
                            width: "100%",
                            backgroundColor: "rgb(249, 250, 251)",
                            borderRadius: 0,
                            "& .MuiInputBase-input": {
                              color: Boolean(
                                errors[`Emergency_wechat_${index + 1}`]
                              ) ? "red" : "black",
                            },
                            "& .MuiOutlinedInput-root": {
                              "& fieldset": {
                                borderColor: Boolean(
                                  errors[`Emergency_wechat_${index + 1}`]
                                )
                                  ? "#ff5e74"
                                  : "rgba(0, 0, 0, 0.23)",
                              },
                              "&:hover fieldset": {
                                borderColor: Boolean(
                                  errors[`Emergency_wechat_${index + 1}`]
                                )
                                  ? "#ff5e74"
                                  : "rgba(0, 0, 0, 0.23)",
                              },
                              "&.Mui-focused fieldset": {
                                borderColor: Boolean(
                                  errors[`Emergency_wechat_${index + 1}`]
                                )
                                  ? "#ff5e74"
                                  : "rgba(0, 0, 0, 0.23)",
                              },
                            },
                          }}
                        />
                      )}
                    />
                              {Boolean(
                                errors[`Emergency_wechat_${index + 1}`]
                              ) ? (
                                <Typography
                                  style={{ color: "#ff5e74", margin: "0.3rem" }}
                                >
                                  {errors[`Emergency_wechat_${index + 1}`]?.message}
                                </Typography>
                              ) : null}
                            </Stack>

                            <Stack sx={{ width: { xs: "100%", lg: "45%" } }}>
                              <InputLabel
                                sx={{
                                  mb: 1,
                                  fontSize: "18px",
                                  fontWeight: 600,
                                  color: "black",
                                }}
                              >
                                {Boolean(errors[`Emergency_line_${index + 1}`])
                                  ? `${t("line")}*`
                                  : `${t("line")}`}
                              </InputLabel>
                              <Controller
                      name={"Emergency_line_" + (index + 1)}
                      control={control}
                      defaultValue={Details?.kakaotalk}
                      rules={{
                        required: false,
                        maxLength: {
                          value: 70,
                          message: "LINE cannot exceed 70 Characters",
                        },
                        minLength : {
                          value: 1,
                          message: "LINE cannot below 1 Characters",
                        }
                      }}
                      render={({ field }) => (
                        <TextField
                          placeholder="Enter line"
                          error={Boolean(
                            errors[`Emergency_line_${index + 1}`]
                          ) ? true : false}
                          {...field}
                          sx={{
                            width: "100%",
                            backgroundColor: "rgb(249, 250, 251)",
                            borderRadius: 0,
                            "& .MuiInputBase-input": {
                              color: Boolean(
                                errors[`Emergency_line_${index + 1}`]
                              ) ? "red" : "black",
                            },
                            "& .MuiOutlinedInput-root": {
                              "& fieldset": {
                                borderColor: Boolean(
                                  errors[`Emergency_line_${index + 1}`]
                                )
                                  ? "#ff5e74"
                                  : "rgba(0, 0, 0, 0.23)",
                              },
                              "&:hover fieldset": {
                                borderColor: Boolean(
                                  errors[`Emergency_line_${index + 1}`]
                                )
                                  ? "#ff5e74"
                                  : "rgba(0, 0, 0, 0.23)",
                              },
                              "&.Mui-focused fieldset": {
                                borderColor: Boolean(
                                  errors[`Emergency_line_${index + 1}`]
                                )
                                  ? "#ff5e74"
                                  : "rgba(0, 0, 0, 0.23)",
                              },
                            },
                          }}
                        />
                      )}
                    />
                              {Boolean(
                                errors[`Emergency_line_${index + 1}`]
                              ) ? (
                                <Typography
                                  style={{ color: "#ff5e74", margin: "0.3rem" }}
                                >
                                  {errors[`Emergency_line_${index + 1}`]?.message}
                                </Typography>
                              ) : null}
                            </Stack>
                          </Box>

                          <Box
                            sx={{
                              display: "flex",
                              justifyContent: "space-around",
                              flexWrap: "wrap",
                              gap: "20px",
                              mt: "20px",
                              mb: "30px",
                            }}
                          >
                            <Stack sx={{ width: { xs: "100%", lg: "45%" } }}>
                              <InputLabel
                                sx={{
                                  mb: 1,
                                  fontSize: "18px",
                                  fontWeight: 600,
                                  color: "black",
                                }}
                              >
                                {Boolean(
                                  errors[`Emergency_kakaotalk_${index + 1}`]
                                )
                                  ? `${t("Kakaotalk")}*`
                                  : `${t("Kakaotalk")}`}
                              </InputLabel>
                              <Controller
                      name={"Emergency_kakaotalk_" + (index + 1)}
                      control={control}
                      defaultValue={Details?.kakaotalk}
                      rules={{
                        required: false,
                        maxLength: {
                          value: 70,
                          message: "Kakaotalk cannot exceed 70 Characters",
                        },
                        minLength : {
                          value: 1,
                          message: "Kakaotalk cannot below 1 Characters",
                        }
                      }}
                      render={({ field }) => (
                        <TextField
                          placeholder="Enter kakaotalk"
                          error={Boolean(
                            errors[`Emergency_kakaotalk_${index + 1}`]
                          ) ? true : false}
                          {...field}
                          sx={{
                            width: "100%",
                            backgroundColor: "rgb(249, 250, 251)",
                            borderRadius: 0,
                            "& .MuiInputBase-input": {
                              color: Boolean(
                                errors[`Emergency_kakaotalk_${index + 1}`]
                              ) ? "red" : "black",
                            },
                            "& .MuiOutlinedInput-root": {
                              "& fieldset": {
                                borderColor: Boolean(
                                  errors[`Emergency_kakaotalk_${index + 1}`]
                                )
                                  ? "#ff5e74"
                                  : "rgba(0, 0, 0, 0.23)",
                              },
                              "&:hover fieldset": {
                                borderColor: Boolean(
                                  errors[`Emergency_kakaotalk_${index + 1}`]
                                )
                                  ? "#ff5e74"
                                  : "rgba(0, 0, 0, 0.23)",
                              },
                              "&.Mui-focused fieldset": {
                                borderColor: Boolean(
                                  errors[`Emergency_kakaotalk_${index + 1}`]
                                )
                                  ? "#ff5e74"
                                  : "rgba(0, 0, 0, 0.23)",
                              },
                            },
                          }}
                        />
                      )}
                    />
                             
                              {Boolean(
                                errors[`Emergency_kakaotalk_${index + 1}`]
                              ) ? (
                                <Typography
                                  style={{ color: "#ff5e74", margin: "0.3rem" }}
                                >
                                  {errors[`Emergency_kakaotalk_${index + 1}`]?.message}
                                </Typography>
                              ) : null}
                            </Stack>

                            <Stack sx={{ width: { xs: "100%", lg: "45%" } }}>
                              <InputLabel
                                sx={{
                                  mb: 1,
                                  fontSize: "18px",
                                  fontWeight: 600,
                                  color: "black",
                                }}
                              >
                                {Boolean(
                                  errors[`Emergency_zalo_${index + 1}`]
                                )
                                  ? `${t("Zalo")}*`
                                  : `${t("Zalo")}`}
                              </InputLabel>
                              <Controller
                      name={"Emergency_zalo_" + (index + 1)}
                      control={control}
                     
                      rules={{
                        required: false,
                        maxLength: {
                          value: 70,
                          message: "Zalo cannot exceed 70 Characters",
                        },
                        minLength : {
                          value: 1,
                          message: "Zalo cannot below 1 Characters",
                        }
                      }}
                      render={({ field }) => (
                        <TextField
                          placeholder="Enter zalo"
                          error={Boolean(
                            errors[`Emergency_zalo_${index + 1}`]
                          ) ? true : false}
                          {...field}
                          sx={{
                            width: "100%",
                            backgroundColor: "rgb(249, 250, 251)",
                            borderRadius: 0,
                            "& .MuiInputBase-input": {
                              color: Boolean(
                                errors[`Emergency_zalo_${index + 1}`]
                              ) ? "red" : "black",
                            },
                            "& .MuiOutlinedInput-root": {
                              "& fieldset": {
                                borderColor: Boolean(
                                  errors[`Emergency_zalo_${index + 1}`]
                                )
                                  ? "#ff5e74"
                                  : "rgba(0, 0, 0, 0.23)",
                              },
                              "&:hover fieldset": {
                                borderColor: Boolean(
                                  errors[`Emergency_zalo_${index + 1}`]
                                )
                                  ? "#ff5e74"
                                  : "rgba(0, 0, 0, 0.23)",
                              },
                              "&.Mui-focused fieldset": {
                                borderColor: Boolean(
                                  errors[`Emergency_zalo_${index + 1}`]
                                )
                                  ? "#ff5e74"
                                  : "rgba(0, 0, 0, 0.23)",
                              },
                            },
                          }}
                        />
                      )}
                    />
                             
                              {Boolean(
                                errors[`Emergency_zalo_${index + 1}`]
                              ) ? (
                                <Typography
                                  style={{ color: "#ff5e74", margin: "0.3rem" }}
                                >
                                  {errors[`Emergency_zalo_${index + 1}`]?.message}
                                </Typography>
                              ) : null}
                            </Stack>
                          </Box>
                        </CardContent>
                      </Card>
                    </Box>
                  </>
                ))}

                <Box
                  sx={{
                    margin: "30px 50px 30px 0px",
                    display: "flex",
                    justifyContent: "flex-end",
                  }}
                >
                  <Button
                    startIcon={<AddContactIcon fill="#FFFFFF" />}
                    // onClick={() => {
                    //   setPersonalData((prev) => ({
                    //     ...prev,
                    //     Emergency_contact: [
                    //       ...prev[`Emergency_contact`],
                    //       initial_Emergency_contact,
                    //     ],
                    //   }));
                    // }}
                    onClick={() => {
                      setPersonalData((prev) => {
                        const updated = {
                          ...prev,
                          Emergency_contact: [
                            ...prev.Emergency_contact,
                            initial_Emergency_contact,
                          ],
                        };
                    
                        const newIndex = updated.Emergency_contact.length - 1;
                    
                        setValue(`Emergency_name_${newIndex + 1}`, "");
                        setValue(`Emergency_contact_no_${newIndex + 1}`, "");
                        setValue(`Emergency_email_${newIndex + 1}`, "");
                        setValue(`Emergency_whatsapp_${newIndex + 1}`, "");
                        setValue(`Emergency_wechat_${newIndex + 1}`, "");
                        setValue(`Emergency_line_${newIndex + 1}`, "");
                        setValue(`Emergency_kakaotalk_${newIndex + 1}`, "");
                        setValue(`Emergency_zalo_${newIndex + 1}`, "");
                    
                        return updated;
                      });
                    }}
                    variant="standard"
                  >
                    {t("Add Another Contact")}
                  </Button>
                </Box>

                <Box
                  sx={{
                    display: "flex",
                    justifyContent: "flex-start",
                    alignItems: "center",
                    backgroundColor: "#FCFCFD",
                    padding: 2,
                    border: "1px solid #E5E7EB",
                    borderRadius: "6px 6px 0px 0px",
                  }}
                >
                  <FormIcon style={{ marginRight: "10px" }} />
                  <Typography variant="h6_1">{t("NOTE")}</Typography>
                </Box>

                <InputLabel sx={{ mt: 3, ml: 4 }} variant="standard">
                  {t("Any Allergies to Food or Medication? If 'Yes' means explain it. If no means please enter 'No'.")}
                </InputLabel>
                <Box sx={{ margin: "25px" }}>
                  <Controller
                    name="note"
                    defaultValue={Details?.note}
                    control={control}
                    rules={{ required: false }}
                    render={({ field }) => (
                      <TextField
                        sx={{
                          ".MuiInputBase-input": { minHeight: "200px" },
                        }}
                        error={Boolean(errors.alergies) ? true : false}
                        {...field}
                        multiline
                      />
                    )}
                  />
                  {errors?.note ? (
                    <Typography style={{ color: "#ff5e74", margin: "0.3rem" }}>
                      Please enter note
                    </Typography>
                  ) : null}
                </Box>

                
<Box
                  sx={{
                    display: "flex",
                    justifyContent: "flex-start",
                    alignItems: "center",
                    backgroundColor: "#FCFCFD",
                    padding: 2,
                    border: "1px solid #E5E7EB",
                    borderRadius: "6px 6px 0px 0px",
                  }}
                >
                  <FormIcon style={{ marginRight: "10px" }} />
                  <Typography variant="h6_1">{t("Upload Passport")}</Typography>
                </Box>

                {Boolean(PassportWatch?.length > 0) ? (
                  // Case when Imgwatch is an array with multiple items
                  Array.from(PassportWatch)?.map((item, index) => (
                    <Stack
                      key={index}
                      direction="row"
                      justifyContent="space-between"
                      alignItems="center"
                      padding="23px"
                      borderRadius="8px"
                      sx={{ border: ".5px solid #1A2461", margin: "20px" }}
                    >
                      <Typography
                        variant="h9_1"
                        sx={{
                          display: "flex",
                          alignItems: "center",
                          gap: "10px",
                        }}
                      >
                        <ImgIcon />
                        {item?.name || item?.originalname}
                      </Typography>
                      <ClearIcon
                        onClick={() => {
                          setValue("passport", null);
                        }}
                        sx={{ color: "#1A2461" }}
                      />
                    </Stack>
                  ))
                ) : PassportWatch ? (
                  // Case when Imgwatch is a single file object
                  <Stack
                    direction="row"
                    justifyContent="space-between"
                    alignItems="center"
                    padding="23px"
                    borderRadius="8px"
                    sx={{ border: ".5px solid #1A2461", margin: "20px" }}
                  >
                    <Typography
                      variant="h9_1"
                      sx={{
                        display: "flex",
                        alignItems: "center",
                        gap: "10px",
                      }}
                    >
                      <ImgIcon />
                      {PassportWatch?.name || PassportWatch?.originalname}
                    </Typography>
                    <ClearIcon
                      onClick={() => {
                        setValue("passport", null);
                      }}
                      sx={{ color: "#1A2461" }}
                    />
                  </Stack>
                ) : (
                  // Case when Imgwatch is null or empty
                  <Box
                    xs={12}
                    onClick={() => passportFile.current.click()}
                    sx={{
                      border: Boolean(errors.passport)
                        ? "1px dashed red"
                        : "1px dashed #1A2461",
                      height: "280px",
                      borderRadius: "8px",
                      backgroundColor: "#F9FBFF",
                      margin: "20px",
                    }}
                  >
                    <Stack
                      direction="column"
                      alignItems="center"
                      justifyContent="center"
                      height="100%"
                    >
                      <Stack
                        direction="row"
                        alignItems="center"
                        justifyContent="center"
                        sx={{
                          height: "100px",
                          width: "100px",
                          borderRadius: "100px",
                          backgroundColor: "#F2F2F2",
                        }}
                      >
                        <UploadFileIcon fill="#1A2461" />
                      </Stack>
                      <Stack
                        mt={2}
                        direction="row"
                        alignItems="center"
                        gap="5px"
                      >
                        <Typography variant="h9_1">{t("Click to upload")}</Typography>
                        <Typography variant="h9_5">{t("or drag and drop")}</Typography>
                      </Stack>
                      <Typography variant="h9_5">
                        {t("Allowed formats")} - PDF, JPEG, PNG
                      </Typography>
                    </Stack>
                  </Box>
                )}

                {/* ))
            ) : (
              
            )} */}

                <Controller
                  name="passport"
                  rules={{ required: true }}
                  control={control}
                  render={({ field }) => (
                    <input
                      type="file"
                      onChange={(e) => {
                        field.onChange(e.target.files);
                      }}
                      ref={(e) => {
                        passportFile.current = e;
                      }}
                      error={Boolean(errors.passportFile) ? true : false}
                      hidden
                    />
                  )}
                />


<Box
                  sx={{
                    display: "flex",
                    justifyContent: "flex-start",
                    alignItems: "center",
                    backgroundColor: "#FCFCFD",
                    padding: 2,
                    border: "1px solid #E5E7EB",
                    borderRadius: "6px 6px 0px 0px",
                  }}
                >
                  <FormIcon style={{ marginRight: "10px" }} />
                  <Typography variant="h6_1">{t("Upload IPA")}</Typography>
                </Box>

                {Boolean(Imgwatch?.length > 0) ? (
                  // Case when Imgwatch is an array with multiple items
                  Array.from(Imgwatch)?.map((item, index) => (
                    <Stack
                      key={index}
                      direction="row"
                      justifyContent="space-between"
                      alignItems="center"
                      padding="23px"
                      borderRadius="8px"
                      sx={{ border: ".5px solid #1A2461", margin: "20px" }}
                    >
                      <Typography
                        variant="h9_1"
                        sx={{
                          display: "flex",
                          alignItems: "center",
                          gap: "10px",
                        }}
                      >
                        <ImgIcon />
                        {item?.name || item?.originalname}
                      </Typography>
                      <ClearIcon
                        onClick={() => {
                          setValue("ipa", null);
                        }}
                        sx={{ color: "#1A2461" }}
                      />
                    </Stack>
                  ))
                ) : Imgwatch ? (
                  // Case when Imgwatch is a single file object
                  <Stack
                    direction="row"
                    justifyContent="space-between"
                    alignItems="center"
                    padding="23px"
                    borderRadius="8px"
                    sx={{ border: ".5px solid #1A2461", margin: "20px" }}
                  >
                    <Typography
                      variant="h9_1"
                      sx={{
                        display: "flex",
                        alignItems: "center",
                        gap: "10px",
                      }}
                    >
                      <ImgIcon />
                      {Imgwatch?.name || Imgwatch?.originalname}
                    </Typography>
                    <ClearIcon
                      onClick={() => {
                        setValue("ipa", null);
                      }}
                      sx={{ color: "#1A2461" }}
                    />
                  </Stack>
                ) : (
                  // Case when Imgwatch is null or empty
                  <Box
                    xs={12}
                    onClick={() => ipaFile.current.click()}
                    sx={{
                      border: Boolean(errors.ipa)
                        ? "1px dashed red"
                        : "1px dashed #1A2461",
                      height: "280px",
                      borderRadius: "8px",
                      backgroundColor: "#F9FBFF",
                      margin: "20px",
                    }}
                  >
                    <Stack
                      direction="column"
                      alignItems="center"
                      justifyContent="center"
                      height="100%"
                    >
                      <Stack
                        direction="row"
                        alignItems="center"
                        justifyContent="center"
                        sx={{
                          height: "100px",
                          width: "100px",
                          borderRadius: "100px",
                          backgroundColor: "#F2F2F2",
                        }}
                      >
                        <UploadFileIcon fill="#1A2461" />
                      </Stack>
                      <Stack
                        mt={2}
                        direction="row"
                        alignItems="center"
                        gap="5px"
                      >
                        <Typography variant="h9_1">{t("Click to upload")}</Typography>
                        <Typography variant="h9_5">{t("or drag and drop")}</Typography>
                      </Stack>
                      <Typography variant="h9_5">
                        {t("Allowed formats")} - PDF, JPEG, PNG
                      </Typography>
                    </Stack>
                  </Box>
                )}

                {/* ))
            ) : (
              
            )} */}

                <Controller
                  name="ipa"
                  rules={{ required: false }}
                  control={control}
                  render={({ field }) => (
                    <input
                      type="file"
                      onChange={(e) => {
                        field.onChange(e.target.files);
                      }}
                      ref={(e) => {
                        ipaFile.current = e;
                      }}
                      error={Boolean(errors.ipa) ? true : false}
                      hidden
                    />
                  )}
                />

                <Stack
                  direction="row"
                  alignItems="center"
                  justifyContent="space-between"
                  sx={{
                    border: "1px solid #E5E7EB",
                    padding: "20px",
                    margin: "50px 0px 0px 0px",
                  }}
                >
                  <Button
                    onClick={() => {
                      setFlowCount(1);
                    }}
                    variant="standard"
                  >
                    {t("Back")}
                  </Button>
                  {/* {verfiyMail ? (<> */}
                  <Button type="submit" variant="standard">
                    {t("Continue")}
                  </Button>
                  {/* </>) : (<>
          <Button disabled={!EmailWatch} onClick={() => {
            handleOtpGenerate()
            handleOpen()
            }} variant="standard">Verify Email</Button>
          </>)
        } */}
                </Stack>
              </Box>
            </form>
          </CardContent>
        </Card>
      </Box>
    </>
  );
}
